import WarningIcon from "@mui/icons-material/Warning";
import { Alert, Box, Tab, Tabs, Typography, useTheme } from "@mui/material";
import React from "react";
import { useMatchEvents } from "../hooks/match_events.hooks";
import { useDirectusMatch } from "../hooks/matches.hooks";
import { LoadingGuard } from "./LoadingGuard";
import { MatchEnigmaStatsDataList } from "./MatchEnigmaStatsDataList";
import { MatchEventsTable } from "./MatchEventsTable";
import { MatchInfoDataList } from "./MatchInfoDataList";
import { MatchEnigmaDetailViewProps } from "./ChallengeMatchOverviewTable/ChallengeMatchOverviewTable.types";

export function MatchEnigmaDetailViewTab({
  value,
  title,
  children,
  index,
}: {
  value: number;
  index: number;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Box hidden={value !== index}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {value === index && children}
    </Box>
  );
}

export function MatchEnigmaDetailView({
  matchId,
  enigmaId,
}: MatchEnigmaDetailViewProps) {
  const [activeTab, setActiveTab] = React.useState(0);
  const [fetchEvents, setFetchEvents] = React.useState(activeTab === 0);
  const [fetchMatch, setFetchMatch] = React.useState(activeTab > 0);
  const [hasInconsistencies, setHasInconsistencies] = React.useState(false);
  const match = useDirectusMatch(matchId, { enabled: fetchMatch });
  const events = useMatchEvents({
    targetId: enigmaId,
    matchId: matchId,
    options: { enabled: fetchEvents },
  });
  const theme  = useTheme();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    if (newValue === 0) {
      setFetchEvents(true);
    } else {
      setFetchMatch(true);
    }
  };

  const checkInconsistencies = () => {};

  return (
    <Box sx={{ p: 2, bgcolor: theme.palette.background.paper }}>
      {hasInconsistencies && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <WarningIcon sx={{ mr: 1 }} />
          Inconsistenze rilevate tra dati aggregati e dettagliati
        </Alert>
      )}

      <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Eventi" />
        <Tab label="Informazioni partita" />
        <Tab label="Statistiche Enigma" />
      </Tabs>

      <MatchEnigmaDetailViewTab
        title={`Eventi (${events.data?.length ?? 0})`}
        index={0}
        value={activeTab}
      >
        <LoadingGuard isLoading={events.isLoading}>
          {events.data && <MatchEventsTable events={events.data} />}
        </LoadingGuard>
      </MatchEnigmaDetailViewTab>
      <MatchEnigmaDetailViewTab
        title="Dettagli match"
        index={1}
        value={activeTab}
      >
        <LoadingGuard isLoading={match.isLoading}>
          {match.data && <MatchInfoDataList match={match.data} />}
        </LoadingGuard>
      </MatchEnigmaDetailViewTab>
      <MatchEnigmaDetailViewTab title="Statistiche" index={2} value={activeTab}>
        <LoadingGuard isLoading={match.isLoading}>
          {match.data && (
            <MatchEnigmaStatsDataList match={match.data} enigmaId={enigmaId} />
          )}
        </LoadingGuard>
      </MatchEnigmaDetailViewTab>
    </Box>
  );
}
